<template>
  <div>
    <!-- <pre>{{ shiftSchedule }}</pre> -->
    <v-layout row>
      <v-flex class="mr-2">
        <date-picker
          v-model="internalShiftStart"
          type="datetime"
          :time-picker-options="{
            start: '06:00',
            step: '00:15',
            end: '23:45'
          }"
          format="ddd, MMM DD YYYY, h:mma"
          placeholder="Shift Start"
        ></date-picker>
        <div class="red--text text-xs pt-2">
          {{ shiftStartMessages() }}
        </div>
      </v-flex>
      <v-flex>
        <date-picker
          v-model="internalShiftEnd"
          type="datetime"
          :time-picker-options="{
            start: '06:00',
            step: '00:15',
            end: '23:45'
          }"
          format="ddd, MMM DD YYYY, h:mma"
          placeholder="Shift End"
        ></date-picker>
        <div class="red--text text-xs pt-2">
          {{ shiftEndMessages() }}
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    DatePicker
  },
  props: [
    "start",
    "end",
    "shiftSchedule",
    "uid",
    "overrideSuggestedEnd",
    "overrideStartLabel",
    "overrideEndLabel"
  ],

  data() {
    return {
      internalShiftStart: null,
      internalShiftEnd: null,
      time1: null,
      // True while the component is syncing internal state from props (initial mount
      // or async prop change). Suppresses the auto-end-overwrite in doShiftStartSetUpdates
      // so loading an existing shift/event preserves both times.
      syncingFromProps: false
    };
  },

  created() {
    this.syncingFromProps = true;
    this.internalShiftStart = this.start;
    this.internalShiftEnd = this.end;
    this.$nextTick(() => { this.syncingFromProps = false; });
  },

  watch: {
    internalShiftStart: "doShiftStartSetUpdates",
    internalShiftEnd: "doShiftEndSetUpdates",
    start(v) {
      if (this.internalShiftStart !== v) {
        this.syncingFromProps = true;
        this.internalShiftStart = v;
        this.$nextTick(() => { this.syncingFromProps = false; });
      }
    },
    end(v) {
      if (this.internalShiftEnd !== v) {
        this.syncingFromProps = true;
        this.internalShiftEnd = v;
        this.$nextTick(() => { this.syncingFromProps = false; });
      }
    }
  },

  computed: {},

  methods: {
    shiftStartMessages() {
      const messages = [];
      if (!this.internalShiftStart) {
        messages.push("Start Time is required");
      }
      if (
        this.internalShiftStart &&
        this.internalShiftEnd &&
        this.internalShiftEnd < this.internalShiftStart
      ) {
        messages.push("Start Time must be before End Time");
      }
      return messages.join(", ");
    },
    shiftEndMessages() {
      const messages = [];
      if (!this.internalShiftEnd) {
        messages.push("End Time is required");
      }
      if (
        this.internalShiftStart &&
        this.internalShiftEnd &&
        this.$moment(this.internalShiftEnd).isBefore(
          this.$moment(this.internalShiftStart)
        )
      ) {
        messages.push("End Time must be after Start Time");
      }
      return messages.join(", ");
    },
    validateTimeOrder() {
      this.startTimeMessages = this.shiftStartMessages;
      this.endTimeMessages = this.shiftEndMessages;
    },
    doShiftStartSetUpdates(value) {
      this.validateShiftStart();
      // this.setRepetitionOptions(value)
      // Skip auto-suggesting an end time during prop sync (e.g., loading an event for edit),
      // so the loaded end isn't overwritten with start + N hours. Only emit updateEnd when
      // we actually changed the end here — otherwise the start watcher firing before the
      // end watcher would broadcast a stale (often null) internalShiftEnd back to the parent.
      if (!this.syncingFromProps) {
        this.updateShiftEnd(value);
        this.$emit("updateEnd", this.internalShiftEnd);
      }
      this.$emit("updateStart", this.internalShiftStart);
    },
    doShiftEndSetUpdates(value) {
      this.validateShiftEnd();
      this.$emit("updateEnd", this.internalShiftEnd);
    },
    validateShiftStart() {
      this.startTimeMessages = this.shiftStartMessages;
    },
    validateShiftEnd() {
      this.endTimeMessages = this.shiftEndMessages;
    },
    updateShiftEnd(value) {
      let suggestedEndTime;
      if (this.overrideSuggestedEnd) {
        suggestedEndTime = this.$moment(value)
          .add(this.overrideSuggestedEnd, "hours")
          .toDate();
      } else {
        suggestedEndTime = this.$moment(value)
          .add(8, "hours")
          .toDate();
      }

      this.internalShiftEnd = suggestedEndTime;

      // Below is code leftover from a previous feature implementation that wasn't used:
      // this.shiftEndProps
      // let dateToShow = this.$moment(value).format('YYYY-MM-DD')
      // payrollStartDate: this.$moment().subtract(3, "weeks").format('YYYY-MM-DD'),
      // this.shiftEndProps = { showCurrent: false }
    }
  }
};
</script>
